import { DatePipe } from "@angular/common";
import { Zone } from "./zone";
import { formatDate } from '@angular/common';


type AlertModule = 'sensor' | 'zone' | 'gateway' | 'cycle' ;

export class AlertLog {

    startDate: Date;
    module: AlertModule;
    moduleName: string;
    type: String;
    visible: Boolean;
    numEvents: Number;
    value: Number;
    at: Number;
    user: any;  
    company: any;
    text: string;

    constructor(data: any) {
        this.company = data.company;
        this.user = data.user;
        this.module = data.refType;
        this.moduleName = data.ref?.name;
        this.type = data.sensorType;
        this.visible = data.visible
        this.startDate = data.startDate;
        this.at = data.at;
        this.value = data.value;
        this.numEvents = data.numEvents;            
        // this.text = data?.text;    
    }

    // get message(): string {
        
    //     try {

    //         if (this.text){
    //             return `
    //                 ${this.text}
    //             `;
    //         }
    //         else{
    //             return 'unknown';
    //         }

    //     } catch (error) {
    //         return 'unknown'
    //     }
    // }
}